<template>

  <AbortStateTemplate
      :headline="headline"
      :message="abortMessage"
      :teaserCards="teaserCardsData"
  />
</template>

  <script>
  import teaserCardsData from "@/data/teaserData";
  import AbortStateTemplate from "@/components/abortStates/AbortStateTemplate.vue";

  export default {
    name: 'StateAbortMonument',
    components: {
      AbortStateTemplate,
    },
    data() {
      return {
        abortMessage:
            "Aufgrund des bestehenden Denkmalschutzes Ihrer Immobilie können wir Ihnen leider kein Angebot für eine Wärmepumpe unterbreiten. Die für den Einbau erforderlichen baulichen Veränderungen stehen im Widerspruch zu den denkmalrechtlichen Auflagen.",
          teaserCardsData
    };
    },
  }
  </script>

